import InlineStyleControls from "./InlineStyleControls";
import {
    FormatBoldRounded,
    FormatItalicRounded,
    FormatListBulletedRounded,
    FormatListNumberedRounded,
    FormatUnderlinedRounded,
    Redo,
    TextFieldsRounded,
    Undo
} from "@material-ui/icons";
import BlockStyleControls from "./BlockStyleControls";
import React from "react";
import UndoRedoControls from "./UndoRedoControls";
import MultiLevelControls from "./MultiLevelControls";
import ToolBar from "./ToolBar";

let Element = props => {
    return <ToolBar>
        { props.options.inline && <InlineStyleControls editorState={ props.editorState }
                                                       onToggle={ props.toggleInlineStyle }
                                                       inlineControls={ [{
                                                           label: 'Bold',
                                                           style: 'BOLD',
                                                           icon: <FormatBoldRounded/>
                                                       }, {
                                                           label: 'Italic',
                                                           style: 'ITALIC',
                                                           icon: <FormatItalicRounded/>
                                                       }, {
                                                           label: 'Underline',
                                                           style: 'UNDERLINE',
                                                           icon: <FormatUnderlinedRounded/>
                                                       }] }
        /> }
        { props.options.blockType && <BlockStyleControls editorState={ props.editorState }
                                                         onToggle={ props.toggleBlockType }
                                                         blockControls={ [{
                                                             label: 'Ordered List',
                                                             style: 'ordered-list-item',
                                                             icon: <FormatListNumberedRounded/>
                                                         }, {
                                                             label: 'Unordered List',
                                                             style: 'unordered-list-item',
                                                             icon: <FormatListBulletedRounded/>
                                                         }, {
                                                             label: 'Title',
                                                             style: 'header-three',
                                                             icon: <TextFieldsRounded/>
                                                         }] }
        /> }
        { props.options.undoRedo &&
            <UndoRedoControls editorState={ props.editorState } onToggle={ props.toggleUndoRedo } isDisabled={props.isDisabled}
                              controls={ [{
                                  label: 'Undo',
                                  icon: <Undo/>
                              }, {
                                  label: 'Redo',
                                  icon: <Redo/>
                              }] }
            /> }
        {props.options.multilevel &&
            <MultiLevelControls toggleMultilevel={props.toggleMultilevel} isDisabled={props.isDisabled}
                                onlyBulletPoint={props.onlyBulletPoint} setIsActiveMultilevel={props.setIsActiveMultilevel}/>}
    </ToolBar>
}

export default Element